import script from "./AppPaginator.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPaginator.vue?vue&type=script&setup=true&lang=js"

import "./AppPaginator.vue?vue&type=style&index=0&id=aadb4910&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aadb4910"]])

export default __exports__